import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignmentProgressContainer = ({
  children
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "stretch",
    flexDirection: "column",
    gap: isMobile ? '100' : '200',
    inlineSize: isMobile ? '100%' : '220px',
    children: children
  });
};
export default AssignmentProgressContainer;